import _ from "lodash";
import { meetingSDK } from "unifiedring-sdk";
import store from "../../context/store/store";
import { UserDetails } from "../../models/model";
import {
  leftBarLoader, storeMeetingPage, savedTemplateLoader,
  storeMeetingList, storeMeetingListInput, storeGetMeetingByDate, storeTemplateListInput, storeTemplateList, storeSortTemplateList, storeMeetingTotalCountList, storeVideoRecordingList, getvideoRecordingList, getvideoRecording
} from "./meetingStoreServices";
import moment from 'moment';
import axios from "axios";
import { saverecordlist } from "../socketChatService/newChat";
import { config } from "../constant";
import { toastInformation } from "../callService/common";
export const getMeetingLists = (data: any) => {
  try {
    leftBarLoader(true);

    let { meetingList } = store.getState().meetingReducer;
    new meetingSDK.MeetingRestService().getMeetingList(data).then((response: any) => {



      if (response?.statusCode === 200) {
        if (data.offset !== 0) {
          if (_.isEmpty(response.result)) {
            //leftBarLoader(false);
            response.result = meetingList.concat(response.result);
          } else {
            response.result = meetingList.concat(response.result);
          }


        }
        storeMeetingListInput(data);
        storeMeetingList(response.result);
        let recdata: any ={};
        recdata.offset = 0;
        recdata.limit = 10;
        recdata.search = "";
        getVideoRecordingLists(recdata);
      }
    });
  }
  catch (error: any) { console.log("error", error); }
};

export const getVideoRecordingLists = async(data : any) =>{
  let { videoRecordingList,recCount } = store.getState().meetingReducer;
  getvideoRecording(videoRecordingList,recCount,true);
  let token: string = store.getState().loginReducer.token;
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };

  try{
    const url: string = `${config().MEET_RESTAPI_URL}/get_meeting_recording_list`;
    await axios.post(url,data, { headers: authkey })
      .then((response: any)=>{ 
        if (response?.data.statusCode === 200) {
          if (data.offset !== 0) {
            if (_.isEmpty(response?.data.result)) {
              response.data.result = videoRecordingList.concat(response.data.result);
            } else {
              response.data.result = videoRecordingList.concat(response.data.result);
            }  
          }
          getvideoRecording(response?.data.result,response.data.count,false);
        storeVideoRecordingList(data);
        if(response?.data?.result?.length > 0){saverecordlist(response?.data?.result[0])}
        }
        else{
          getvideoRecording(videoRecordingList,recCount,false);
          storeVideoRecordingList(videoRecordingList);
        }
    })
  }
  catch (error: any){
    console.log("error", error);
  }  
}

export const deleteRecord =async (data:any) => {
  let token: string = store.getState().loginReducer.token;
  var headers:any = {
    "Content-Type": "application/json",
    Authorization: token
  };
  

  const url: any = `${config().MEET_RESTAPI_URL}/delete_meeting_recording_list`;
  try{
    let {detailPage} = store.getState().meetingReducer;
   await axios.delete(url,
    {data:data,
    headers:headers})
      .then((response: any)=>{
        if (response?.data.statusCode === 200) {
         let recdata: any ={};
         recdata.offset = 0;
         recdata.limit = 10;
         recdata.search = detailPage.uuid;
         getVideoRecordingLists(recdata)
         toastInformation('Recorded video deleted', "success");
        }
    })
  }
  catch (error: any){
    console.log("error", error);
  } 
}

export const scrollgetMeetingLists = (data: any) => {
  try {
    leftBarLoader(true);
    let { meetingList } = store.getState().meetingReducer;

    new meetingSDK.MeetingRestService().getMeetingList(data).then((response: any) => {
      leftBarLoader(false);
      if (response?.statusCode === 200) {
        if (data.offset !== 0) {
          if (_.isEmpty(response.result)) {
            // leftBarLoader(false);
            response.result = meetingList?.concat(response.result);
          } else {
            response.result = meetingList?.concat(response.result);
          }


        }
        storeMeetingListInput(data);
        storeMeetingList(response.result);
      }
    });
  }
  catch (error: any) { console.log("error", error); }
};


export const addParticipantsService = (data: any) => {
  try {
    //leftBarLoader(true);


    /*    console.log("addParticipants >>>>>", data);
       let token:string = store.getState().loginReducer.token;
       var authkey = {
         "Content-Type": "application/json",
         Authorization: token
       }; */
    return new Promise((resolve, reject) => {
      new meetingSDK.MeetingRestService().bulkaddParticipants(data).then((response: any) => {
        if (response?.statusCode === 200) { resolve(response); }
      });
    })


    /*      axios.post('https://stageurapi.worktual.co.uk/urmeet/v2/meetings/add_participants_v2', data, { headers: authkey }).then((response: any) => {
          console.log(response);
          console.log("response is", response.data);
    
        }); */
  }
  catch (error: any) { console.log("error", error); }
};
export const getMeetingByDate = (date: any) => {
  try {
    new meetingSDK.MeetingRestService().getMeetingByDate(date).then((response: any) => {
      if (response?.statusCode === 200) {
        storeGetMeetingByDate(response.result, date)
      }
    });
  }
  catch (error: any) { console.log("error", error); }
};

export const updateMeetingTotalBatch = () => {
  try{
  new meetingSDK.MeetingRestService().meetingReadCount().then((result: any) => {
    if (result?.statusCode === 200) {
      //console.log("Batch Count Result --->", result);
      storeMeetingTotalCountList(result);
    }
  });
}
catch (error: any) { console.log("error", error); }
}

export const updateMeetingRead = (uuid: string) => {
  try {
  return new Promise((resolve, reject) => {
    let { meetingList } = store.getState().meetingReducer;
    let meetingReducer: any = store.getState().meetingReducer;
    const {meetingCountStatus} =meetingReducer;
    if(meetingCountStatus){
    new meetingSDK.MeetingRestService().updateMeetingsRead(uuid).then((result: any) => {
      console.log("Meeting Result --->", result);
      updateMeetingTotalBatch();
      meetingList.map((value: any) => {
        if (value?.uuid === uuid) {
          console.log("Message Readed !!!");
          value.ReadFlag = 0;
          return value;
        } else {
          return value;
        }
      })
    })
    resolve(meetingList);
  }
  })
}
  catch (error: any) { console.log("error", error); }

}
export const cancelMeetingUuid = (uuid: any, detailPage: any) => {
  let { getListInput } = store.getState().meetingReducer;
  return new Promise((resolve, reject) => {
    return new meetingSDK.MeetingRestService().cancelMeetingByUuid(uuid).then((response: any) => {
      if (response?.statusCode === 200) {
        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        let updatedInfo: any = detailPage;
        updatedInfo = {
          ...updatedInfo, status: "Cancelled"
        };
        storeMeetingPage(updatedInfo);
        resolve(response);
      }
      else {
        resolve("error")
      }
    });
  })
};

export const savedTemplateTitle = (templateId: any, data: string) => {
  return new meetingSDK.MeetingRestService().saveAsTemplateTitle(templateId, data).then((response: any) => {
    return response;
  })
}

export const editMeetingApi = (uuid: any, data: any) => {
  let { getListInput } = store.getState().meetingReducer;
  return new Promise((resolve, reject) => {
    new meetingSDK.MeetingRestService().editMeetingByUuid(uuid, data).then((response: any) => {
      if (response?.statusCode === 200) {
        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        resolve(response);
      }
      else {
        resolve("error")
      }
    });
  })
};

export const deleteMeetingUuid = (uuid: any) => {
  let { getListInput } = store.getState().meetingReducer;
  return new Promise((resolve, reject) => {
    new meetingSDK.MeetingRestService().deleteMeeting(uuid).then((response: any) => {
      if (response?.statusCode === 200) {
        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        resolve(response);;
      }
      else {
        resolve("error")
      }
    });
  })
};

export const getTemplateList = (data: any, input: any) => {
  savedTemplateLoader(true);
  let { getTemplateListInput, templateList } = store.getState().meetingReducer;
  return new meetingSDK.MeetingRestService().getTemplatesList(data).then((res: any) => {
    if (res.statusCode === 200) {
      savedTemplateLoader(false);
      if (getTemplateListInput.offset !== 0) {
        if (_.isEmpty(res.result)) {
          res.result = templateList.concat(res.result);
        }
        else {
          res.result = templateList.concat(res.result);
        }
      } else {
        res.result = templateList.concat(res.result);

      }
      let value: any = {};
      value.isDate = (data.sortType === 'date') ? data.sort : input.isDate;
      value.isTitle = (data.sortType === 'title') ? data.sort : input.isTitle;
      storeTemplateList(res.result);
      storeTemplateListInput(data);
      storeSortTemplateList(value);
    }
    return res;
  })
    .catch((err: any) => {
      console.log("error", err)
    });
}

export const deleteMeetingTemplate = (templateId: any) => {
  let { getTemplateListInput, storeTemplateListSortValue } = store.getState().meetingReducer;
  return new Promise((resolve, reject) => {
    new meetingSDK.MeetingRestService().deleteTemplate(templateId).then((response: any) => {
      if (response.statusCode === 200) {
        storeTemplateList([]);
        let input: any = {};
        input.isDate = storeTemplateListSortValue.isDate;
        input.isTitle = storeTemplateListSortValue.isTitle;
        let data: any = {};
        data.offset = 0;
        data.limit = getTemplateListInput.limit;
        data.sort = (getTemplateListInput.sortType === 'date') ? storeTemplateListSortValue.isDate : storeTemplateListSortValue.isTitle;
        data.sortType = getTemplateListInput.sortType;
        getTemplateList(data, input);
      }
      resolve(response);
    })
  })
};

export const createScheduleMeeting = () => {

};

export const editScheduleTemplate = () => {

};

export const createInstantMeeting = () => {

};

export const joinMeetingStatus = () => {

};

export const getMeetingId = () => {
  let data: UserDetails = store.getState().loginReducer.userdetails || [];
  return data.meeting_id || '';
};

